<template>
  <div class="wrapper-order wh100p">
    <section class="section-navs df">
      <div class="nav _themecolor active f-m">{{$t('orderNew.orderNewManage')}}</div>
    </section>

    <section class="section-search _bordertop df-c-sb">
      <div class="df-c-fs box">
        <input type="number" class="input" :placeholder="$t('order.searchContent')" v-model.number="searchKey" @input="searchClick" @focus="onFocus_forScan" @blur="onBlur_forScan" >
        <img src="@/assets/icons/magnifier.png" class="icon">
        <div class="text f-xs" @click="searchKey='',searchClick()">{{$t('common.clear')}}</div>
      </div>
    </section>


    <section class="section-table">
      <div class="table-box" ref="tablebox">
        <el-table
          ref="multipleTable"
          :data="tableDatas"
          :max-height="tableMaxHeight"
          :row-class-name="tableRowClassName"
          @row-click="rowClickedHandler">
          <!-- :max-height="(pageData.pageSize+1)*50" -->
          <!-- stripe border highlight-current-row -->
          <!-- :row-class-name="tableRowClassName" -->
          <el-table-column type="expand">
            <template slot-scope="props">
              <div class="demo-table-expand" v-if="props.row.cartItems.length">
                <div class="row mb10" v-for="(x,i) in props.row.cartItems" :key="i">
                  <div class="df-c-sb">
                    <div class="df-c-fs sls f1">
                      <div class="f-xs f-black sls f1">{{x['itemName'+_lang]}}</div>
                      <div class="f-xs ml20">x{{x.count}}</div>
                    </div>
                    <div class="btns df-c-fs ml40">
                      <img class="subtract-btn"
                        :src="iconSubtract1"
                        @click.prevent.stop="subtractClick(props.row,x.id)">
                      <!-- <img class="subtract-btn ml10"
                        :src="iconDelete"
                        @click.prevent.stop="deleteClick(props.row,x.id)"> -->
                      <span class="f-xs delete-btn ml20" @click.prevent.stop="deleteClick(props.row,x.id)">{{$t('common.delete')}}</span>
                    </div>
                  </div>
                  <div>
                    <CartItemDetail :item="x" :fontSize="14" />
                  </div>
                </div>
              </div>
              <div v-else>{{$t('food.noItem')}}</div>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip v-for="(x,i) in tableOptions" :key="i"
            :prop="x.key" :label="$t('order.'+x.key)" :min-width="x.width||'80'" :align="x.align||'center'"></el-table-column>
          <el-table-column :label="$t('order.userCost')" min-width="80" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.userCost|toprice(2)}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column :label="$t('orderNew.detail')" min-width="80" align="center">
            <template slot-scope="scope">
              <div v-for="(x,i) in scope.row.cartItems" :key="i">
                <span>{{x['itemName'+_lang]}}</span>
                <span>x{{x.count}}</span>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column :label="$t('common.action')" width="480" align="center">
            <template slot-scope="scope">
              <template v-if="scope.row.status===0">
                <div class="df-c-sa plr20">
                  <div class="agreepay-btn df-c-ct f-white _themebackground" @click.stop.prevent="auditAndOrderClick(scope.row,1)">{{$t('orderNew.agreeOrder')}}</div>
                  <div class="agreepay-btn df-c-ct f-white _themebackground" @click.stop.prevent="auditAndPayClick(scope.row,1)">{{$t('orderNew.agreePay')}}</div>
                  <div class="agree-btn df-c-ct f-white _themebackground" @click.stop.prevent="auditClick(scope.row,1)">{{$t('orderNew.agree')}}</div>
                  <div class="refuse-btn df-c-ct" @click.stop.prevent="auditClick(scope.row,2)">{{$t('orderNew.refuse')}}</div>
                </div>
              </template>
              <template v-if="scope.row.status===1">
                <div class="_themecolor">{{$t('orderNew.agreed')}}</div>
              </template>
              <template v-if="scope.row.status===2">
                <div class="_redcolor">{{$t('orderNew.refused')}}</div>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <Pagenation :pageData="pageData" @pageChange="pageChange" />
    </section>

  </div>
</template>

<script>
import mixin_table_simple from '@/mixins/mixin_table_simple'
export default {
  name: 'orderNew',
  mixins: [mixin_table_simple],
  inject: ['waitingOrderSearch'],
  data() {
    return {
      searchKey: '',
      
      tableOptions: [
        { key: 'orderNo', width: '60' }, // 单号
        { key: 'codeText', width: '80' }, // 台号/电话/姓名
        // { key: 'userCost', width: '60' }, // 消费金额
      ],
      tableDatas: [],
      tableIndex: '',
      tableRow: {},
      rowSelected: [],

      timer_order: null,

      otherHeight: 340,
    }
  },
  methods: {
    tableRowClassName({row, rowIndex}) {
      if (row.orderType === 2) {
        return 'yellow-row'
      }
      return ''
    },
    rowClickedHandler(row, column, event) {
      console.log(`%crow, column, event:`, 'color: #00f;', row, column, event)
      this.$refs.multipleTable.toggleRowExpansion(row)
    },

    // 重置data
    resetPageData() {
      this.pageData.currentPage = 1
      this.tableDatas = []
      this.tableIndex = ''
      this.tableRow = {}
      this.rowSelected = []
    },

    // 点击搜索
    searchClick(autoOnlyBendRead = false) {
      this.pageData.currentPage = 1
      this.search(autoOnlyBendRead)
    },
    // 搜索
    async search(autoOnlyBendRead = false) {
      let rD = {
        shopId: this.currentShopId,
        sortField: ['createTime'],
        sortType: 'DESC',
        pageSize: this.pageData.pageSize,
        pageNumber: this.pageData.currentPage,
        businessEndShow: true,
        filterCheckoutOrderItem: true,
        status: 0,
        autoOnlyBendRead,
      }
      // 關鍵詞
      if (Number(this.searchKey)) {
        rD.orderNo = Number(this.searchKey)
        rD.contact = Number(this.searchKey)
      }
    
      const _R = await this.getData('audit', rD, { replace: true })
      // console.log(`%c查询的订单:`, 'color: #f00;', _R)

      const ARR_NEW = _R.map((x, i) => {
        let newItem = {}
        newItem.id = x.id
        newItem.userCost = x.cash
        newItem.status = x.status
        newItem.orderNo = x.orderNo
        newItem.orderId = x.orderId
        newItem.orderType = x.orderType
        if (x.code) {
          newItem.codeText = x.code + (x.showNo > 1 ? ('-' + x.showNo ) : '')
        } else if (x.contact) {
          newItem.codeText = x.contact
        } else {
          newItem.codeText = ''
        }

        newItem.cartItems = x.orderItemDetailList
        
        return newItem
      })
      // console.log(`%c处理后订单:`, 'color: #00f;', ARR_NEW)

      // 更新左侧菜单栏提示数量
      this.waitingOrderSearch()

      if (JSON.stringify(this.tableDatas) !== JSON.stringify(ARR_NEW)) {
        this.tableDatas = []
        this.$nextTick(() => {
          this.tableDatas = ARR_NEW
        })
      }
      
      if (this.searchKey === '') {
        this.timer_order && clearInterval(this.timer_order)
        this.timer_order = setInterval(() => {
          // console.log(`%c定时器执行了:`, 'color: #00f;', )
          this.search(true)
        }, 30000)
      } else {
        this.timer_order && clearInterval(this.timer_order)
      }
    },

    async auditAndOrderClick(row, status) {
      // console.log(row)
      await this.auditClick(row, status)
      
      let type = ''
      switch (row.orderType) {
        case 1: type = 'normal'; break
        // case 2: type = 'edit'; break // 這裡因為菜單頁面對takeaway進行置空處理，用edit代替判斷
        // // case 3: type = 'normal'; break
        // case 4: type = 'edit'; break // 這裡因為菜單頁面對takeaway進行置空處理，用edit代替判斷
        
        case 2: case 4:
          if (row.takeoutSettingId) {
            type = 'editcustom&payId=' + row.takeoutSettingId
          } else {
            type = 'edit' // 這裡因為菜單頁面對takeaway進行置空處理，用edit代替判斷
          }
          break
      }
      this.$router.push(`/menu?oid=${row.orderId}&type=${type}`)
    },
    async auditAndPayClick(row, status) {
      // console.log(row)
      await this.auditClick(row, status)
      this.editOrderClick(row)
    },
    // 編輯订单
    editOrderClick(row) {
      // console.log(`%crow:`, 'color: #00f;', row, row.status, row.userSelectPayType)
      // if (row.cartItems.length === 0) {
      //   return
      // }
      switch (row.status) {
        case 4: case 7: case 9:
          this.$router.push(`/calcwayFood?oid=${row.orderId}`)
          break
        case 5: case 8:
          this.$router.push(`/calcwayAvg?oid=${row.orderId}`)
          break
        case 6: case 10:
          this.$router.push(`/calcwayCus?oid=${row.orderId}`)
          break
        case 100:
          switch (row.userSelectPayType) {
            case 2:
              this.$router.push(`/calcwayAvg?oid=${row.orderId}`)
              break;
            case 3:
              this.$router.push(`/calcwayCus?oid=${row.orderId}`)
              break;
            case 4:
              this.$router.push(`/calcwayFood?oid=${row.orderId}`)
              break;
            default:
              this.$router.push(`orderDetail?oid=${row.orderId}`)
              break;
          }
          break
        default:
          this.$router.push(`/calcway?oid=${row.orderId}`)
          break
      }
    },
    
    // 同意 拒绝
    async auditClick(row, status) {
      // this.bellRing_x_save(false)

      this.tableRow = row
      // console.log(`%crow:`, 'color: #00f;', row)
      // 0表示没有操作，1表示通过，2表示失败
      const _D = await this.setData('audit', {
        shopId: this.currentShopId,
        id: row.id,
        status,
      })
      if (_D) {
        this.searchClick()
        this.waitingOrderSearch()
      }
      await this.getAllOrderLength()
    },
    // 数量减1
    subtractClick(row, itemId) {
      let { orderId, id } = row
      // console.log(`%cresult:`, 'color: #00f;', id, orderId, itemId)
      this.itemCountChange({
        shopId: this.currentShopId,
        orderId,
        id,
        orderItemId: itemId,
        count: -1,
      }, row)
    },
    // 删除
    deleteClick(row, itemId) {
      let { orderId, id } = row
      // console.log(`%cresult:`, 'color: #00f;', id, orderId, itemId)
      this.itemCountChange({
        shopId: this.currentShopId,
        orderId,
        id,
        orderItemId: itemId,
        deleteItem: true
      }, row)
    },
    itemCountChange(params, row) {
      this.$api.orderNew_set(params).then(res => {
        if (res.status == 0) {
          let _R = res.data
          // console.log(`%c操作结果:`, 'color: #f00;', _R)
          if (_R.status === 2) {
            this.search()
          } else {
            row.cartItems = _R.orderItemDetailList
          }
        } else { this._status(res) }
      })
    },

    async getAllOrderLength() {
      let rD = {
        shopId: this.currentShopId,
        pageSize: 9999,
        businessEndShow: true,
        filterCheckoutOrderItem: true,
        status: 0,
      }
      const _R = await this.getData('audit', rD)
      this.bellOrderIds_x_save(_R.map(x1 => x1.id))
    },
    
    getTableData() {
      this.search()
    },
    // 获取数据
    init() {
      this.search()
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.searchClick(true)
    })
  },
  beforeRouteLeave(to, from, next) {
    this.timer_order && clearInterval(this.timer_order)
    this.$refs.multipleTable.clearSelection()
    next()
  },
}
</script>

<style lang='scss' scoped>
@import '@/assets/css/util_table.scss';
.section-navs{
  height: 80px;line-height: 80px;background: #fff;padding: 0 10px;
  overflow: scroll hidden;z-index: 3;position: relative;
  .nav{padding: 0 10px;width: auto;white-space: nowrap;}
  .nav.active{font-weight: bold;}
}

.section-search{
  height: 80px;background: #fff;z-index: 3;position: relative;padding: 0 20px;box-sizing: border-box;
  .box{position: relative;}
  .input{width: 300px;height: 36px;border: none;background: #EEEEEF;border-radius: 8px;padding: 0 36px;box-sizing: border-box;}
  .icon{position: absolute;left: 8px;top: 0;bottom: 0;margin: auto;width: 20px;height: 20px;}
  .text{color: #1890FF;padding: 20px 10px 20px 30px;}
}

.section-table{
  height: calc(100% - 180px);margin-top: 20px;
  .table-box{height: calc(100% - 100px);overflow: hidden scroll;}

  .agreepay-btn{width: 120px;height: 30px;}
  .agree-btn{width: 80px;height: 30px;}
  .refuse-btn{width: 80px;height: 30px;box-sizing: border-box;border: 1px solid #374978;position: relative;background: #fff;}
  .row{
    width: 42%;
    .btns{width: 80px;}
    .subtract-btn{width: 24px;height: 24px;border-radius: 50%;}
    // .delete-btn{width: 70px;height: 30px;line-height: 30px;text-align: center;background: #000;color: #fff;font-size: 16px;border-radius: 4px;}
    .delete-btn{color: #374978;}
  }

  .section-total{height: 50px;line-height: 50px;padding: 0 40px;}
  .section-btns{
    position: absolute;bottom: 20px;right: 20px;
    .btn{margin: 20px;}
  }

}
/deep/.el-table{
  .yellow-row{background: #FCFDE0;}
  .gray-row{color: #999;}
  
  .demo-table-expand {
    .row{
      line-height: 24px;
    }
  }
}


// 頁碼
/deep/.el-pagination{text-align: left;margin-left: 40px;}
</style>